// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__T4fYt","dark-wrapper":"Header_dark-wrapper__2CkG7","inner":"Header_inner__bgcbu"};